<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.img" class="flex-shrink-0 mr-2" size="30px" />
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
    }
</script>
